import {EtrValidationResult} from "./EtrValidationResult";
import {Optional} from "../../../../../js/util/Optional";
import {OrderSide} from "../../../../../orders/models/OrderRecord";

export interface EtrValidationParams {
    readonly bid?: number | null;
    readonly bidLimit: number;
    readonly ask?: number | null;
    readonly askLimit: number;
}

export class OrderValidation {

    public static validateEtr(price: number, side: OrderSide, params: EtrValidationParams, isAdviser: boolean): EtrValidationResult {
        if (isAdviser) {
            return {
                price,
                limit: null,
                outsideEtr: false,
                etrWarning: false
            };
        }

        const isBuy = side === OrderSide.BUY;

        const bid = Optional.of(params.bid).orNull();
        const ask = Optional.of(params.ask).orNull();
        const bidEtrLimit = params.bidLimit;
        const askEtrLimit = params.askLimit;

        /* ExtremeTradingRangeVettingService on the server has the same logic as this */
        if (isBuy) {
            return this.validateBuyEtr(price, ask, askEtrLimit);
        } else {
            return this.validateSellEtr(price, bid, bidEtrLimit);
        }
    }

    private static validateBuyEtr(price: number, ask: number | null, askLimit: number): EtrValidationResult {
        if (askLimit == null) {
            return {
                price,
                limit: null,
                outsideEtr: false,
                etrWarning: false
            };
        }

        const limit = ask == null ? askLimit : Math.max(ask, askLimit);
        const outsideEtr = price > limit;
        const etrWarningLimit = askLimit * (price < 0 ? 1.1 : 0.9);
        const priceAboveAsk = ask != null && price > ask;
        const etrWarning = priceAboveAsk && price > etrWarningLimit;

        return {
            price,
            limit,
            outsideEtr,
            etrWarning
        };
    }

    private static validateSellEtr(price: number, bid: number | null, bidLimit: number): EtrValidationResult {
        if (bidLimit == null) {
            return {
                price,
                limit: null,
                outsideEtr: false,
                etrWarning: false
            };
        }

        const limit = bid != null ? Math.min(bid, bidLimit) : bidLimit;

        const outsideEtr = price < limit;
        const etrWarningLimit = bidLimit * 1.1;
        const priceBelowBid = bid != null && price < bid;
        const etrWarning = priceBelowBid && price < etrWarningLimit;

        return {
            price,
            limit,
            outsideEtr,
            etrWarning
        };
    }
}
